import DoctorContainer from 'components/Doctor';
import FilterDrawer from 'components/FilterDrawer';
import Logo from './styles';
import Viz from 'components/Viz';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setParticlesSize } from 'redux/general/actions';
import store from 'redux/store';
import assets from 'shared/assets';

import dataJson from 'shared/data';
import { MCCILogo } from './styles';
import DoctorAnimated from 'components/DoctorAnimated';
import Modal from 'components/Modal';

const VizScreen = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState(dataJson);
  const {filters} = useSelector((r) => r.general);

  console.log('fil', filters);

  useEffect(() => {
    const newData = dataJson.filter((em) => {
      if(filters.name !== "" && !em.name.includes(filters.name)){
        return false;
      }

      if(filters.institution !== "" && !em.hospital.includes(filters.institution)){
        return false;
      }

      if(filters.type == "photo" && em.photo !== "Fotografía"){
        return false;
      }

      if(filters.type !== "*" && !filters.type.includes(em.type) && !filters.type.includes('photo')){
        return false;
      }

      

      const minAge = filters.age[0];
      const maxAge = filters.age[1];

      if((em.age < minAge || em.age > maxAge) && em.age !== "S/D"){
        return false;
      }

      if(filters.gender !== "*" && !filters.gender.includes(em.gender)){
        return false;
      }

      if(filters.category !== "*" && !filters.category.includes(em.category)){
        return false;
      }

      if(filters.state !== "*" && filters.state !== em.status){
        return false;
      }


      return true;





    })


    setData(newData);

    if(newData.length !== store.getState().general.particlesSize){
      dispatch(setParticlesSize(newData.length));
    }

  }, [filters.age, filters.type, filters.gender, filters.category, filters.state, filters.name, filters.institution])


  return(
    <>
      <DoctorAnimated />
      <Viz data={data}/>
      <FilterDrawer />
      <Modal />
      {/* <Logo src={assets.logo} /> */}
      {/* <MCCILogo src={assets.mcci} /> */}
    </>
  )
}

export default VizScreen;